/**
 * @file Case Study Parallax Image Fade.
 */

/**
 * Case Study Parallax Image Fade effect.
 */
const csParallaxImageFade = () => {

	const {vLib}            = window || {};
	const parallaxImgs      = [...document.querySelectorAll('.a-cs-parallax-image__img')];

	if (parallaxImgs.length) {
		const isMobileFade      = matchMedia( '(max-width: 550px)' );
		const parallaxParents   = [...parallaxImgs].map(el => el.closest('.a-cs-parallax-image'));
		let parentTops        = [];
		let parentHeights     = [];
		let imgFadeStates     = [];
		const sectionImgs       = document.querySelectorAll('.a-cs-section-media__media:not(.a-cs-section-media__media--tablet):not(.a-cs-section-media__media--mobile)')
		const sectionOverlays   = document.querySelectorAll('.a-cs-section-media__overlay');
		const sectionParents    = [...sectionImgs].map(el => el.closest('.a-cs-section-media'));
		let sectionTops       = [];
		let sectionHeights    = [];
		let sectionFadeStates = [];
		let windowHeight        = window.outerHeight;
		let scrollPos           = window.scrollY;
		let isMobile            = document.querySelector('.a-cs-parallax-image').style.float !== 'left';

		const initValues = () => {
			parentTops        = [...parallaxParents].map(el => el.offsetTop);
			parentHeights     = [...parallaxParents].map(el => el.getBoundingClientRect().height);
			imgFadeStates     = [...parallaxImgs].map(el => false);
			sectionTops       = [...sectionParents].map(el => el.offsetTop);
			sectionHeights    = [...sectionParents].map(el => el.getBoundingClientRect().height);
			sectionFadeStates = [...sectionImgs].map(el => false);
			windowHeight      = window.outerHeight;
			scrollPos         = window.scrollY;
			isMobile          = document.querySelector('.a-cs-parallax-image').style.float !== 'left';
		};

		/**
		 * Fade parallax images.
		 *
		 * @param el The image.
		 * @param i Index of the image.
		 */
		function fadeParallax( el, i ) {
			const topFromWindowTop       = parentTops[ i ] - scrollPos;
			const topFromWindowBottom    = topFromWindowTop - windowHeight;
			const bottomFromWindowTop    = topFromWindowTop + parentHeights[ i ];
			const bottomFromWindowBottom = bottomFromWindowTop - ( windowHeight - scrollPos );

			const percFromBottom = topFromWindowBottom / windowHeight;
			const percFromTop    = bottomFromWindowTop / windowHeight;

			if ( ( percFromBottom < -.5 && percFromTop > .5 ) ) {
				if ( imgFadeStates[ i ] ) {
					parallaxImgs[ i ].style.opacity = 1;
					imgFadeStates[ i ] = false;
				}
			} else if ( ! imgFadeStates[ i ] ) {
				if ( isMobileFade.matches ) {
					parallaxImgs[ i ].style.opacity = .5;
				} else {
					parallaxImgs[ i ].style.opacity = .2;
				}
				imgFadeStates[ i ] = true;
			}
		}

		/**
		 * Fade Blocks.
		 *
		 * @param el The image.
		 * @param i Index of the image.
		 */
		function fadeBlock( el, i ) {
			const topFromWindowTop       = sectionTops[ i ] - scrollPos;
			const topFromWindowBottom    = topFromWindowTop - windowHeight;
			const bottomFromWindowTop    = topFromWindowTop + sectionHeights[ i ];
			const bottomFromWindowBottom = bottomFromWindowTop - ( windowHeight - scrollPos );

			const percFromBottom = topFromWindowBottom / windowHeight;
			const percFromTop    = bottomFromWindowTop / windowHeight;

			if ( ( percFromBottom < -.5 && percFromTop > .5 ) ) {
				if ( sectionFadeStates[ i ] ) {
					// $( this ).css( 'opacity', 0 );
					sectionOverlays[ i ].style.opacity = 0;
					sectionFadeStates[ i ] = false;
				}
			} else if ( ! sectionFadeStates[ i ] ) {
				if ( isMobileFade.matches ) {
					// $( this ).css( 'opacity', .5 );
					sectionOverlays[ i ].style.opacity = .5;
				} else {
					// $( this ).css( 'opacity', .8 );
					sectionOverlays[ i ].style.opacity = .8;
				}
				sectionFadeStates[ i ] = true;
			}
		}

		/**
		 * Fade images on scroll.
		 */
		function fadeImages() {
			if ( vLib.overlayIsOpen ) {
				return;
			}

			scrollPos = window.scrollY;
			[...parallaxImgs].forEach( fadeParallax );
			if ( isMobile ) {
				[...sectionOverlays].forEach( fadeBlock );
			}
		}

		// initValues();
		// fadeImages();

		window.addEventListener('scroll', fadeImages);
		window.addEventListener('resize', () => {
			initValues();
			fadeImages();
		});
		setTimeout(() => {
			initValues();
			fadeImages();
		}, 600)
	}
};

export default csParallaxImageFade;
